module.exports = __webpack_public_path__ + "img/k3.4a5aa570.jpg";